import React, { Component } from 'react'
import Select from 'react-select'

// Components
import SelectMultiOption from './SelectMultiOption'
import Label from '../../label'

class SelectBox extends Component {
  constructor (props) {
    super(props)
    this.onChange = this.onChange.bind(this)
    this.formatOptionLabel = this.formatOptionLabel.bind(this)
  }

  onChange (data) {
    const { onChange, isMulti, name } = this.props

    if (onChange !== null) {
      let value
      if (isMulti) {
        value = [ ...new Set(data.map(opt => opt.value)) ]
      } else {
        value = data.value
      }

      const event = {
        target: {
          name: name,
          value: value,
          type: isMulti ? 'select-multiple' : 'select-one'
        },
        // Dummy function
        persist: () => {}
      }

      onChange(event)
    }
  }

  formatOptionLabel (option, meta) {
    if (meta.context === 'value') {
      return option.label
    }

    const label = (typeof option.label === 'number') ? `${option.label}` : option.label
    const optionClass = option.className || ''

    if (!this.props.isMulti) {
      return (
        <div className={'option-container element-dropdown__option ' + optionClass}>
          <Label>{label}</Label>
        </div>
      )
    }

    return (
      <SelectMultiOption
        label={label}
        selected={this.props.isSelected(option)}
        disabled={option.disabled}
        size={this.props.size}
        className={optionClass}
      />
    )
  }

  render () {
    let { name, options, value, disabled, isMulti, isSearchable, show, openOnTop } = this.props

    let customComponents = {}
    if (isSearchable) {
      customComponents.IndicatorSeparator = null
      // customComponents.DropdownIndicator = () => (
      //   <Icon icon={ElementIcons.Check_Normal} className='normal' size={this.props.size} />
      // )
    } else {
      customComponents.Control = () => null
    }

    let visibilityStyles = {}
    let visibilityStylesMenu = {}
    if (!show) {
      visibilityStyles.display = 'none'
    }

    if (openOnTop) {
      /* visibilityStyles.bottom = '100%' */

      visibilityStylesMenu.top = 'auto'
      visibilityStylesMenu.bottom = '0'
      visibilityStylesMenu.marginBottom = '0'
    }

    const renderSearch = (content) => {
      return (
        <div className='drop__search'>
          {content}
        </div>
      )
    }

    const renderSelect = () => {
      return (
        <Select
          ref='dropDownSelect'
          classNamePrefix='drop'
          name={name}
          value={value}
          options={options}
          placeholder='Search'
          isDisabled={disabled}
          onChange={this.onChange}
          styles={{ container: (provided, state) => ({ ...provided, ...visibilityStyles }), menu: (provided, state) => ({ ...provided, ...visibilityStylesMenu }) }}

          formatOptionLabel={this.formatOptionLabel}
          isOptionDisabled={opt => opt.disabled}

          menuIsOpen
          isMulti={isMulti}
          hideSelectedOptions={false}
          backspaceRemovesValue={false}
          closeMenuOnSelect={!isMulti}
          blurInputOnSelect={!isMulti}
          controlShouldRenderValue={false}
          isClearable={false}
          tabSelectsValue={false}

          onMenuClose={() => this.refs.dropDownSelect.blur()}
          components={customComponents}
          captureMenuScroll
          closeMenuOnScroll
          // menuShouldBlockScroll
          // menuPortalTarget={document.body}   // Doesn't work. React version issue??
          // menuPlacement={'auto'}
          // menuPosition={'fixed'}
        />
      )
    }

    return isSearchable ? renderSearch(renderSelect()) : renderSelect()
  }
}

SelectBox.defaultProps = {
  size: 's',
  name: null,
  onChange: null,
  value: null,
  options: null,
  disabled: false,
  show: false,
  isMulti: false,
  isSearchable: false,
  isSelected: () => console.error('isSelected() is required in Select')
}

export default SelectBox



// WEBPACK FOOTER //
// ./src/app/shared/elements/dropDown/SelectBox/index.js